import "bootstrap-icons/font/bootstrap-icons.css";
import { Navigate } from "react-router-dom";
import {
  Button,
  Card,
  DatePicker,
  Form,
  Input,
  Modal,
  Table,
  Tag,
  Tooltip,
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { PlusOutlined } from "@ant-design/icons";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import {
  loadAllAttendancePaginated,
  saveCheckOutTime,
} from "../../redux/rtk/features/attendance/attendanceSlice";
import { VioletLinkBtn } from "../UI/AllLinkBtn";
import BtnSearchSvg from "../UI/Button/btnSearchSvg";
import { CsvLinkBtn, TableHeraderh2 } from "../UI/CsvLinkBtn";
import { TimePicker } from "antd";
import moment from "moment";
import Search from "antd/es/transfer/search";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import getUserFromToken from "../../utils/getUserFromToken";
import Attendance from "./AddAttendance";
import PageTitle from "../page-header/PageHeader";

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Asia/Kolkata");

// Date functionalities
let StartDate = dayjs().startOf("month");
let EndDate = dayjs().endOf("month");

function CustomTable({ list = [], total, status, setStatus, loading }) {
  const [columnsToShow, setColumnsToShow] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const [outTimeDate, setOutTimeDate] = useState({
    time: null,
    date: null,
  });

  const outTimeDateNew =
    outTimeDate.date && outTimeDate.time
      ? new Date(
          Date.UTC(
            outTimeDate.date.split("-")[0],
            outTimeDate.date.split("-")[1] - 1,
            outTimeDate.date.split("-")[2],
            ...outTimeDate.time.split(":").map(Number)
          )
        )
      : null;

  const onChange = (value) => {
    setStatus(value);
    dispatch(
      loadAllAttendancePaginated({
        Month: dayjs(StartDate).month() + 1, // Derive Month from StartDate
        Year: dayjs(StartDate).year(), // Derive Year from StartDate
      })
    );
  };

  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "serial",
      key: "serial",
    },
    {
      id: 10,
      title: "User",
      dataIndex: "EmployeeName",
      key: "EmployeeName",
    },

    {
      title: "In Time",
      dataIndex: "PunchInTime",
      key: "PunchInTime",
      render: (PunchInTime) => {
        if (!PunchInTime || isNaN(dayjs(PunchInTime).valueOf())) return "N/A";
        return dayjs(PunchInTime).utc().format("DD-MM-YYYY, HH:mm A");
      },
    },
    // {
    //   id: 7,
    //   title: "Punch In By",
    //   dataIndex: "PunchInByName",
    //   key: "PunchInByName",
    // },
    {
      id: 7,
      title: "Punch In Remarks",
      dataIndex: "PunchInRemark",
      key: "PunchInRemark",
    },
    {
      title: "Out Time",
      dataIndex: "PunchOutTime",
      key: "PunchOutTime",
      render: (PunchOutTime) => {
        if (!PunchOutTime || isNaN(dayjs(PunchOutTime).valueOf())) return "N/A";
        return dayjs(PunchOutTime).utc().format("DD-MM-YYYY, HH:mm A");
      },
    },
    {
      id: 7,
      title: "Punch Out Remarks",
      dataIndex: "PunchOutRemark",
      key: "PunchOutRemark",
    },
    {
      id: 6,
      title: "Total Hour",
      dataIndex: "TodayHours",
      key: "TodayHours",
      render: (TodayHours) =>
        TodayHours ? TodayHours.toFixed(2) : "Not Checked",
    },
    {
      id: 8,
      title: "Action",
      dataIndex: "PunchOutTime",
      key: "PunchOutTime",
      render: (PunchOutTime, record) => {
        const buttonStyle = {
          padding: "4px 8px",
          backgroundColor: "#FF5733",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
          fontSize: "14px",
          transition: "background-color 0.3s",
        };

        const messageStyle = {
          color: "#4CAF50",
          fontSize: "14px",
          fontWeight: "bold",
        };

        return !PunchOutTime ? (
          <button
            style={buttonStyle}
            onClick={() => handleCheckOut(record)}
            onMouseEnter={(e) => (e.target.style.backgroundColor = "#C70039")}
            onMouseLeave={(e) => (e.target.style.backgroundColor = "#FF5733")}
          >
            Check Out
          </button>
        ) : (
          <span style={messageStyle}>Already Checked Out</span>
        );
      },
    },
  ];

  const handleCheckOut = (record) => {
    setSelectedRecord(record);
    form.setFieldsValue({
      ...record,
      user: `${record?.EmployeeName}`,
      PunchInTime: dayjs(record.PunchInTime).utc(),
      PunchOutTime: record.PunchOutTime
        ? dayjs(record.PunchOutTime).utc()
        : null,
    });
    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
    form.resetFields();
  };

  const handleModalSubmit = async () => {
    try {
      const values = await form.validateFields();
      const PunchInTime = values.PunchInTime;
      const PunchOutTime = outTimeDateNew;

      if (
        PunchOutTime &&
        PunchInTime &&
        dayjs(PunchOutTime).isBefore(dayjs(PunchInTime))
      ) {
        toast.error("Out time cannot be earlier than In time.");
        return;
      }

      const resultAction = await dispatch(
        saveCheckOutTime({
          id: selectedRecord.userId,
          PunchOutTime:
            PunchOutTime instanceof Date && !isNaN(PunchOutTime)
              ? PunchOutTime
              : null,
          checkOutComment: values.checkOutComment,
        })
      );

      if (saveCheckOutTime.fulfilled.match(resultAction)) {
        dispatch(
          loadAllAttendancePaginated({
            Month: dayjs(StartDate).month() + 1, // Derive Month from StartDate
            Year: dayjs(StartDate).year(), // Derive Year from StartDate
          })
        );
      } else {
        toast.error("Failed to save check-out time.");
      }
      setIsModalVisible(false);
      form.resetFields();
    } catch (info) {
      // console.error("Validate Failed:", info);
    }
  };

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  const addKeys = (arr) =>
    arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

  useEffect(() => {
    if (Array.isArray(list)) {
      const filtered = list.filter((item) => {
        const fullName = `${item.EmployeeName}`.toLowerCase();
        return fullName.includes(searchText.toLowerCase());
      });
      setFilteredList(filtered);
    } else {
      setFilteredList([]);
    }
  }, [list, searchText]);

  const csvData = Array.isArray(filteredList) && filteredList.length > 0
    ? filteredList.map((item, index) => ({
        S_No: index + 1,
        EmployeeName: item.EmployeeName || "N/A",
        Date: item.DateValue
          ? dayjs(item.DateValue).utc().format("DD-MM-YYYY")
          : "N/A",
        WeekNumber: item.WeeklyNumberName || "N/A",
        WeekDay: item.WeeklyDayName || "N/A",
        IsWeekHoliday: item.IsWeekHoliday ? "Yes" : "No",
        IsPublicHoliday: item.IsPublicHoliday ? "Yes" : "No",
        PublicHolidayName: item.PublicHolidayName || "N/A",
        IsPresent: item.IsPresent ? "Yes" : "No",
        PunchInTime: item.PunchInTime
          ? dayjs(item.PunchInTime).utc().format("DD-MM-YYYY, HH:mm A")
          : "N/A",
        PunchInRemark: item.PunchInRemark || "N/A",
        HasPunchOut: item.HasPunchOut ? "Yes" : "No",
        PunchOutTime: item.PunchOutTime
          ? dayjs(item.PunchOutTime).utc().format("DD-MM-YYYY, HH:mm A")
          : "N/A",
        PunchOutRemark: item.PunchOutRemark || "N/A",
        WorkingHours: item.WorkingHours ? item.WorkingHours.toFixed(2) : "0.00",
        IsWorkingDay: item.IsWorkingDay ? "Yes" : "No",
        IsPresent: item.IsPresent ? "Yes" : "No",
        IsOnDutyPresent: item.IsOnDutyPresent ? "Yes" : "No",
        IsWorkFromHomePresent: item.IsWorkFromHomePresent ? "Yes" : "No",
        IsRemotePresent: item.IsRemotePresent ? "Yes" : "No",
        IsOnLeave: item.IsOnLeave ? "Yes" : "No",
        IsPaidLeave: item.IsPaidLeave ? "Yes" : "No",
        IsUnPaidLeave: item.IsUnPaidLeave ? "Yes" : "No",
        IsShortLeave: item.IsShortLeave ? "Yes" : "No",
        IsShortLeaveOnStart: item.IsShortLeaveOnStart ? "Yes" : "No",
        IsShortLeaveOnMid: item.IsShortLeaveOnMid ? "Yes" : "No",
        IsShortLeaveOnEnd: item.IsShortLeaveOnEnd ? "Yes" : "No",
        IsHalfDayOnStart: item.IsHalfDayOnStart ? "Yes" : "No",
        IsHalfDayOnMid: item.IsHalfDayOnMid ? "Yes" : "No",
        IsHalfDayOnEnd: item.IsHalfDayOnEnd ? "Yes" : "No",
        IsLeaveWithoutInform: item.IsLeaveWithoutInform ? "Yes" : "No",
        IsOverTime: item.IsOverTime ? "Yes" : "No",
        IsComboOff: item.IsComboOff ? "Yes" : "No",
      }))
    : list.map((item, index) => ({
        S_No: index + 1,
        EmployeeName: item.EmployeeName || "N/A",
        Date: item.DateValue
          ? dayjs(item.DateValue).utc().format("DD-MM-YYYY")
          : "N/A",
        WeekNumber: item.WeeklyNumberName || "N/A",
        WeekDay: item.WeeklyDayName || "N/A",
        IsWeekHoliday: item.IsWeekHoliday ? "Yes" : "No",
        IsPublicHoliday: item.IsPublicHoliday ? "Yes" : "No",
        PublicHolidayName: item.PublicHolidayName || "N/A",
        IsPresent: item.IsPresent ? "Yes" : "No",
        PunchInTime: item.PunchInTime
          ? dayjs(item.PunchInTime).utc().format("DD-MM-YYYY, HH:mm A")
          : "N/A",
        PunchInRemark: item.PunchInRemark || "N/A",
        HasPunchOut: item.HasPunchOut ? "Yes" : "No",
        PunchOutTime: item.PunchOutTime
          ? dayjs(item.PunchOutTime).utc().format("DD-MM-YYYY, HH:mm A")
          : "N/A",
        PunchOutRemark: item.PunchOutRemark || "N/A",
        WorkingHours: item.WorkingHours ? item.WorkingHours.toFixed(2) : "0.00",
        IsWorkingDay: item.IsWorkingDay ? "Yes" : "No",
        IsPresent: item.IsPresent ? "Yes" : "No",
        IsOnDutyPresent: item.IsOnDutyPresent ? "Yes" : "No",
        IsWorkFromHomePresent: item.IsWorkFromHomePresent ? "Yes" : "No",
        IsRemotePresent: item.IsRemotePresent ? "Yes" : "No",
        IsOnLeave: item.IsOnLeave ? "Yes" : "No",
        IsPaidLeave: item.IsPaidLeave ? "Yes" : "No",
        IsUnPaidLeave: item.IsUnPaidLeave ? "Yes" : "No",
        IsShortLeave: item.IsShortLeave ? "Yes" : "No",
        IsShortLeaveOnStart: item.IsShortLeaveOnStart ? "Yes" : "No",
        IsShortLeaveOnMid: item.IsShortLeaveOnMid ? "Yes" : "No",
        IsShortLeaveOnEnd: item.IsShortLeaveOnEnd ? "Yes" : "No",
        IsHalfDayOnStart: item.IsHalfDayOnStart ? "Yes" : "No",
        IsHalfDayOnMid: item.IsHalfDayOnMid ? "Yes" : "No",
        IsHalfDayOnEnd: item.IsHalfDayOnEnd ? "Yes" : "No",
        IsLeaveWithoutInform: item.IsLeaveWithoutInform ? "Yes" : "No",
        IsOverTime: item.IsOverTime ? "Yes" : "No",
        IsComboOff: item.IsComboOff ? "Yes" : "No",
      }));

  // Updated headers to match the fields in csvData
  const headers = [
    { label: "S.No", key: "S_No" },
    { label: "Employee Name", key: "EmployeeName" },
    { label: "Date", key: "Date" },
    { label: "Week Number", key: "WeekNumber" },
    { label: "Week Day", key: "WeekDay" },
    { label: "Week Holiday", key: "IsWeekHoliday" },
    { label: "Public Holiday", key: "IsPublicHoliday" },
    { label: "Public Holiday Name", key: "PublicHolidayName" },
    { label: "Has Punch In", key: "IsPresent" },
    { label: "Punch In Time", key: "PunchInTime" },
    { label: "Punch In Remark", key: "PunchInRemark" },
    { label: "Has Punch Out", key: "HasPunchOut" },
    { label: "Punch Out Time", key: "PunchOutTime" },
    { label: "Punch Out Remark", key: "PunchOutRemark" },
    { label: "Working Hours", key: "WorkingHours" },
    { label: "Is Working Day", key: "IsWorkingDay" },
    { label: "Is Present", key: "IsPresent" },
    { label: "Is On Duty Present", key: "IsOnDutyPresent" },
    { label: "Is Work From Home Present", key: "IsWorkFromHomePresent" },
    { label: "Is Remote Present", key: "IsRemotePresent" },
    { label: "Is On Leave", key: "IsOnLeave" },
    { label: "Is Paid Leave", key: "IsPaidLeave" },
    { label: "Is Unpaid Leave", key: "IsUnPaidLeave" },
    { label: "Is Short Leave", key: "IsShortLeave" },
    { label: "Is Short Leave On Start", key: "IsShortLeaveOnStart" },
    { label: "Is Short Leave On Mid", key: "IsShortLeaveOnMid" },
    { label: "Is Short Leave On End", key: "IsShortLeaveOnEnd" },
    { label: "Is Half Day On Start", key: "IsHalfDayOnStart" },
    { label: "Is Half Day On Mid", key: "IsHalfDayOnMid" },
    { label: "Is Half Day On End", key: "IsHalfDayOnEnd" },
    { label: "Is Leave Without Inform", key: "IsLeaveWithoutInform" },
    { label: "Is Over Time", key: "IsOverTime" },
    { label: "Is Combo Off", key: "IsComboOff" },
  ];

  const showModal = () => {
    setIsModalVisible(true);
  };

  return (
    <div className="mt-5">
      {list && (
        <div className="text-center my-2 flex justify-end">
          <div className="mb-4">
            <Search
              placeholder="Search by name..."
              allowClear
              size="large"
              onChange={(e) => setSearchText(e.target.value)}
              style={{ maxWidth: "400px" }}
            />
          </div>
          <CsvLinkBtn>
            <CSVLink
              data={csvData}
              headers={headers}
              filename={`attendance_${dayjs().format("YYYY-MM-DD")}.csv`}
              className="btn btn-primary"
              target="_blank"
            >
              Download CSV
            </CSVLink>
          </CsvLinkBtn>
        </div>
      )}

      {list && (
        <div style={{ marginBottom: "30px" }}>
          <ColVisibilityDropdown
            options={columns}
            columns={columns}
            columnsToShowHandler={columnsToShowHandler}
          />
        </div>
      )}

      <Table
        scroll={{ x: true }}
        loading={loading}
        columns={columnsToShow}
        dataSource={filteredList ? addKeys(filteredList) : []}
      />

      <Modal
        title="Checkout Details"
        visible={isModalVisible}
        onCancel={handleModalCancel}
        footer={[
          <Button key="cancel" onClick={handleModalCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={handleModalSubmit}>
            Submit
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="User"
            name="user"
            rules={[{ required: true, message: "User is required" }]}
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
            label="In Time"
            name="PunchInTime"
            rules={[{ required: true, message: "In Time is required" }]}
          >
            <DatePicker showTime format="DD-MM-YYYY, h:mm A" disabled />
          </Form.Item>
          <Form.Item style={{ marginBottom: "10px" }} label="End Time">
            <div className="flex justify-between">
              <DatePicker
                format={"YYYY-MM-DD"}
                onChange={(date, dateString) =>
                  setOutTimeDate({ ...outTimeDate, date: dateString })
                }
              />
              <TimePicker
                className="ml-4"
                format={"HH:mm:ss"}
                onChange={(time, timeString) =>
                  setOutTimeDate({ ...outTimeDate, time: timeString })
                }
              />
            </div>
          </Form.Item>
          <Form.Item label="Comment" name="checkOutComment">
            <Input.TextArea rows={3} placeholder="Enter your comment here" />
          </Form.Item>
          <Form.Item label="Punch By" name="punchBy">
            <Input disabled />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

const GetAllAttendance = (props) => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state?.attendance)||[];
  const [status, setStatus] = useState("true");
  const EmployeeId = getUserFromToken(); // Get EmployeeId
  const { RangePicker } = DatePicker;
  const [isModalVisible, setIsModalVisible] = useState(false);
  useEffect(() => {
    dispatch(
      loadAllAttendancePaginated({
        Month: dayjs(StartDate).month() + 1, // Derive Month from StartDate
        Year: dayjs(StartDate).year(), // Derive Year from StartDate
      })
    );
  }, []);

  const onCalendarChange = (dates) => {
    StartDate = dates?.[0] ? dayjs(dates[0]).toDate() : null;
    EndDate = dates?.[1] ? dayjs(dates[1]).endOf("day").toDate() : null;
  };

  const defaultValue = [dayjs(StartDate), dayjs(EndDate)];

  const onClickSearch = () => {
    dispatch(
      loadAllAttendancePaginated({
        Month: dayjs(StartDate).month() + 1, // Derive Month from StartDate
        Year: dayjs(StartDate).year(), // Derive Year from StartDate
      })
    );
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  // Handle modal close
  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const isLogged = Boolean(localStorage.getItem("isLogged"));

  if (!isLogged) {
    return <Navigate to={"/admin/auth/login"} replace={true} />;
  }

  return (
    <>
            <PageTitle title={"Back"} />
    <Card className="">
      <div className="card-body">
        <div className="flex justify-between">
          <div className="flex items-center">
            <TableHeraderh2>Attendance List</TableHeraderh2>
            <Tooltip title="Add Attendance">
              <Button
                type="primary" // Changed from "text" to "primary" for visibility
                icon={<PlusOutlined style={{ fontSize: "20px" }} />}
                onClick={showModal}
                style={{
                  marginLeft: "30px",
                  backgroundColor: "#1890ff", // Ant Design primary blue
                  borderColor: "#1890ff",
                  color: "#fff",
                  boxShadow: "0 2px 8px rgba(24, 144, 255, 0.6)", // subtle glow effect
                }}
              />
            </Tooltip>
          </div>
          <div className="flex justify-end">
            <RangePicker
              onCalendarChange={onCalendarChange}
              defaultValue={defaultValue}
              format={"DD-MM-YYYY"}
              className="range-picker mr-3"
              style={{ maxWidth: "400px" }}
            />
            <VioletLinkBtn>
              <button onClick={onClickSearch}>
                <BtnSearchSvg size={25} title={"SEARCH"} loading={loading} />
              </button>
            </VioletLinkBtn>
          </div>
        </div>
        <CustomTable
          list={list}
          loading={loading}
          total={100}
          StartDate={StartDate}
          EndDate={EndDate}
          status={status}
          setStatus={setStatus}
        />
      </div>
      <Modal
        title="Add Manual Attendance"
        visible={isModalVisible}
        onCancel={handleModalCancel}
        footer={null} // No footer buttons, as Attendance component has its own submit button
        width={500}
      >
        <Attendance drawer={false} />
      </Modal>
    </Card>
    </>
  );
};

export default GetAllAttendance;
